<script lang="ts">
  import EventCard from '$src/js/modules/events/EventCard.svelte';
  import Svg from '$src/js/modules/ui/components/Svg.svelte';
  import type { R2RSubmissions } from '$src/types/events';
  import type { ResponseStatus } from '$src/types/forms';

  const submissions: R2RSubmissions[] = window.submissions;

  const handleDeleteParticipant = async (
    eventId: number,
    submissionId: number | undefined
  ) => {
    if (!eventId || !submissionId) {
      return;
    }

    const formData = new FormData();
    formData.append('elementId', eventId.toString());
    formData.append('submissionId', submissionId.toString());

    const response = await fetch('/api/users/submissions/delete/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRF-Token': window.csrfTokenValue,
      },
      body: JSON.stringify(Object.fromEntries(formData.entries())),
    });

    const responseData = (await response.json()) as {
      status: ResponseStatus;
      message: string;
    };

    if (!response.ok || responseData.status !== 'success') {
      alert('Sorry, het is niet gelukt om de deelnemer te verwijderen.');
      return;
    }

    location.reload();
  };
</script>

{#if !submissions.length}
  <div class="2xl:fluid-gap-[16] flex flex-col gap-4">
    <p class="text-16px font-bold">Je hebt nog geen aanmeldingen.</p>
    <p class="text-16px">
      Bekijk de kalender om deelnemers voor een Ready2Race evenement aan te
      melden.
    </p>
  </div>
{:else}
  <div class="2xl:fluid-gap-[32] flex flex-col gap-8">
    {#each submissions as event (event.slug)}
      <div>
        <EventCard {event} mode="detail" />
        <div
          class="bg-white-100 text-14px 2xl:fluid-p-[16] flex flex-col gap-4 p-4"
        >
          {#each event.participants as participant (participant.id)}
            <div
              class="flex flex-col justify-between gap-1 lg:flex-row lg:gap-2"
            >
              <p class="flex items-center">
                <Svg
                  image="check"
                  width={16}
                  height={16}
                  className="2xl:fluid-w-[16] 2xl:fluid-h-[16] fill-primary"
                />
              </p>
              <p class="lg:w-[30%]">
                {participant.firstName}
                {participant.lastName}
              </p>
              <p class="lg:w-[35%]">
                {#if !event.clinicType}
                  {participant.raceClass ?? 'N/A'}
                {:else if participant.isBikeOwner}
                  Heeft een eigen fiets
                {:else}
                  Geen eigen fiets ({participant.height}cm)
                {/if}
              </p>
              <button
                aria-label="Verwijder deelnemer"
                onclick={() =>
                  handleDeleteParticipant(event.id, participant.submission_id)}
              >
                <Svg
                  image="cross-normal"
                  width={20}
                  height={20}
                  className="2xl:fluid-w-[20] 2xl:fluid-h-[20] fill-error-light"
                />
              </button>
            </div>
          {/each}
        </div>
      </div>
    {/each}
  </div>
{/if}
